module.exports = __webpack_public_path__ + "img/BDL.22015fa1.svg";